/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerformata4portrait3Inputs */

const en_flyerformata4portrait3 = /** @type {(inputs: Flyerformata4portrait3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A4 portrait`)
};

const de_flyerformata4portrait3 = /** @type {(inputs: Flyerformata4portrait3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A4 Hochformat`)
};

/**
* | output |
* | --- |
* | "A4 portrait" |
*
* @param {Flyerformata4portrait3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerformata4portrait3 = /** @type {((inputs?: Flyerformata4portrait3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerformata4portrait3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerformata4portrait3(inputs)
	return de_flyerformata4portrait3(inputs)
});
export { flyerformata4portrait3 as "flyerFormatA4Portrait" }